var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformancescience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64213",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00018 21C4.15018 21 3.54602 20.6208 3.18768 19.8625C2.82935 19.1042 2.91685 18.4 3.45018 17.75L9.00018 11V5H8.00018C7.71685 5 7.47935 4.90417 7.28768 4.7125C7.09602 4.52083 7.00018 4.28333 7.00018 4C7.00018 3.71667 7.09602 3.47917 7.28768 3.2875C7.47935 3.09583 7.71685 3 8.00018 3H16.0002C16.2835 3 16.521 3.09583 16.7127 3.2875C16.9044 3.47917 17.0002 3.71667 17.0002 4C17.0002 4.28333 16.9044 4.52083 16.7127 4.7125C16.521 4.90417 16.2835 5 16.0002 5H15.0002V11L20.5502 17.75C21.0835 18.4 21.171 19.1042 20.8127 19.8625C20.4544 20.6208 19.8502 21 19.0002 21H5.00018ZM5.00018 19H19.0002L13.0002 11.7V5H11.0002V11.7L5.00018 19Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformancescience);
export default __webpack_public_path__ + "static/media/Performance science.2f6e074e.svg";
export { ForwardRef as ReactComponent };